import { createSlice } from "@reduxjs/toolkit";
import { getFarmVisitReport } from "./actions/farmVisitReportAction";

const initialState = {
    farmVisitReport: null,
    total: 0,
    loading: false,
    pageState: { page: 1, pageSize: 50 },
};

export const farmVisitReportSlice = createSlice({
    name: "farmVisitReport",
    initialState,
    reducers: {
        setFarmVisitReportPage: (state, action) => {
            const { page, pageSize } = action.payload;
            if (page) {
                state.pageState = {
                    ...state.pageState,
                    page,
                };
            }
            if (pageSize) {
                state.pageState = {
                    ...state.pageState,
                    pageSize,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFarmVisitReport.pending, (state) => {
                state.loading = true;
            })
            .addCase(getFarmVisitReport.fulfilled, (state, action) => {
                const { data, count } = action.payload;
                state.loading = false;
                state.farmVisitReport = data;
                state.total = count;
            })
            .addCase(getFarmVisitReport.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const { setFarmVisitReportPage } = farmVisitReportSlice.actions;

export default farmVisitReportSlice.reducer;
